<template>
  <modal
    :ctrl="ctrl"
    :positiveLabel="{
      text: $t('OK')
    }"
    :negativeLabel="{ text: $t('CANCEL') }"
    @closed="stopWorkers"
  >
    <div>
      <div
        class="ui indicating progress"
        :class="{ active: progress.total !== progress.done }"
        :data-percent="progress.percent * 100"
      >
        <div class="bar" style="display: block;" :style="`width: ${progress.percent * 100}%`">
          <div class="progress">{{ progress.done }}/{{ progress.total }}</div>
        </div>
        <div class="label">
          {{
            $t('LOOKING_FOR', {
              thing: $t('USES_OF', { thing: `${flowsInvoking.module}.${flowsInvoking.method}` }),
              found: $tc('LOCATION_COUNT', progress.found)
            })
          }}
        </div>
      </div>
      <div class="results">
        <div v-for="(n, appId) in matchTree" :key="appId">
          <div class="application" @click.prevent="n.open = !n.open">
            <div class="name">{{ n.application.name }}</div>
            <div class="ui mini circular label count">{{ n.count }}</div>
          </div>
          <div class="flows" v-show="n.open">
            <div
              class="flow"
              v-for="(m, flowId) in n.flows"
              :key="flowId"
              @click="m.open = !m.open"
            >
              <div class="name">{{ m.flow.name }}</div>
              <div class="ui mini circular label count">{{ m.contexts.length }}</div>
              <div class="contexts" v-show="m.open">
                <div class="context" v-for="(c, idx) in m.contexts" :key="flowId + '_' + idx">
                  <pre class="monospaced" v-html="c" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<style lang="scss" scoped>
.results {
  max-height: 300px;
  overflow: auto;
}

.application {
  cursor: pointer;
  .name {
    display: inline-block;
    font-weight: bold;
    margin-top: 0.5em;
    margin-bottom: 0.3em;
  }
  .count {
    display: inline-block;
  }
}

.flow {
  cursor: pointer;
  margin-left: 0.8em;
  .count,
  .name {
    display: inline-block;
  }
}
</style>

<script>
// @flow
import Vue from 'vue'
import { Modal } from 'ui'
import { Flow, Application } from 'services'
import Worker from 'worker-loader!./ParseWorker.js'

export default {
  name: 'affected-modal',

  props: ['ctrl', 'flowsInvoking'],

  components: { Modal },

  data() {
    return {
      progress: { total: 0, percent: 0, done: 0, left: 0, elapsed: 0, found: 0 },
      matchTree: {},
      workers: []
    }
  },

  computed: {
    flows() {
      return this.$store.state.flow.items
    },
    flowsById() {
      return _.keyBy(this.flows, 'id')
    },
    applications() {
      return this.$store.state.application.items
    },
    applicationsById() {
      return _.keyBy(this.applications, 'id')
    }
  },

  methods: {
    stopWorkers() {
      console.debug('stopping workers', this.workers?.length)
      _.each(this.workers, worker => worker.w?.terminate())
    }
  },

  created() {
    Flow.readAllFlows()
    Application.readAllApps()
  },

  watch: {
    flowsInvoking: function() {
      const t0 = Date.now()
      const flows = [...this.flows]

      // Setup worker pool, 4 workers
      this.workers = _.times(4, i => ({ name: `worker #${i}`, w: new Worker() }))

      this.progress = { total: 0, percent: 0, done: 0, left: 0, elapsed: 0, found: 0 }
      this.progress.total = this.progress.left = this.flows.length
      this.matchTree = {}

      const doWork = (flows, worker) => {
        const flow = flows.pop()

        if (flow) {
          this.progress.left--
          worker.w.postMessage({
            job: { flowId: flow.id, code: flow.code, invocation: this.flowsInvoking }
          })
        } else {
          console.debug(`No flows left for ${worker.name}`)
          //worker.w.terminate()
        }
      }

      // spin up workers
      _.each(this.workers, worker => {
        worker.w.onerror = console.error
        worker.w.onmessage = msg => {
          if (msg.data?.done) {
            this.progress.done++
            this.progress.percent = this.progress.done / this.progress.total
            this.progress.elapsed = Date.now() - t0
            doWork(flows, worker)
          } else if (msg.data.flowId) {
            const flow = this.flowsById[msg.data.flowId]
            this.$set(
              this.matchTree,
              flow.application,
              this.matchTree[flow.application] || {
                application: this.applicationsById[flow.application],
                flows: {},
                count: 0,
                open: false
              }
            )
            this.$set(
              this.matchTree[flow.application].flows,
              flow.id,
              this.matchTree[flow.application].flows[flow.id] || { flow, contexts: [], open: false }
            )

            this.matchTree[flow.application].flows[flow.id].contexts.push(msg.data.context)
            this.matchTree[flow.application].count++
            this.progress.found++
          }
        }

        // get started
        doWork(flows, worker)
      })
    }
  }
}
</script>
